import { advisorColorClass, advisorInitials } from '@/lib/foh/advisorInitials';
import { cn } from '@/lib/utils';

/** OCT28 #6: the primary advisor's colour-coded initials (the name is the tooltip / accessible label). */
export function AdvisorInitialsBadge({ userId, name, className }: { userId: string; name: string | null; className?: string }) {
  const label = name ? `Advisor: ${name}` : 'Advisor';
  return (
    <span
      data-testid="advisor-initials"
      title={label}
      aria-label={label}
      className={cn('inline-flex h-6 min-w-6 items-center justify-center rounded-full px-1 text-[11px] font-semibold',
        advisorColorClass(userId), className)}
    >
      {advisorInitials(name)}
    </span>
  );
}
